import { useState } from "react";
import { useTranslation } from "react-i18next";
import OrdersTable from "@/components/organisms/OrdersTable";
import { DEFAULT_ORDER_COLUMNS } from "@/components/organisms/OrdersTable/const/default";
import OrdersFilter from "@/components/organisms/OrdersTable/OrdersFilter";
import Heading from "@/components/atoms/Heading";
import OrderCalendar from "@/components/organisms/OrderCalendar";
import styles from "./styles.module.css";
import { Box } from "@mantine/core";
import { useAuth } from "@/contexts/AuthContext";
import { useGetCompanyById } from "@/services/Company";
import { SubHeader } from "@/components/molecules/SubHeader";

export default function MyOrders() {
  const { t } = useTranslation();
  const { currentCompany } = useAuth();
  const { data: company } = useGetCompanyById(currentCompany?.companyId as number, {
    enabled: !!currentCompany?.companyId,
  });
  const [totalItems, setTotalItems] = useState(0);

  return (
    <>
      <title>{`Reviver - ${t("dashboard:myOrders")}`}</title>
      <meta name="description" content={`Reviver - ${t("dashboard:myOrders")}`} />
      <SubHeader title={t("navigation:orders")} count={totalItems} countLabel={t("common:orders")} />
      <Box className={styles.contentRoot}>
        <div className={styles.contentInner}>
          <OrdersFilter />
          <OrdersTable visibleColumns={DEFAULT_ORDER_COLUMNS} onTotalItemsChange={setTotalItems} />
          {company?.isOrderPlanningEnabled && (
            <>
              <Heading order={1} styleOrder={4} strong mb={24} mt={32}>
                {t("orders:orderCalendar")}
              </Heading>
              <OrderCalendar />
            </>
          )}
        </div>
      </Box>
    </>
  );
}
